import React from "react";

import * as theme from "./theme.css";

interface TagAndCategoryListContainerProps {
    children: React.ReactNode;
}

export function TagAndCategoryListContainer({
    children,
}: TagAndCategoryListContainerProps) {
    return <div className={theme.tagAndCategoryListContainer}>{children}</div>;
}
